import Constants from 'expo-constants';
import { config } from '@/config';

export const API_URL = config.api.baseURL;
export const PAIRING_LINK_BASE_URL = config.pairingLink.baseURL;
export const UNLOCK_CODE = config.unlockCode;

// The three dub.co download links (see components/MobileGate.tsx). Composed here
// rather than spelled out per stage in config/, because only the host differs —
// this way no stage can end up with a typo'd path or a missing utm_source.
//
// utm_source marks installs that came from the TV web app, so they can be told
// apart from organic store traffic.
const DOWNLOAD_UTM_SOURCE = 'utm_source=tv_app';
const downloadBaseURL = config.downloadLink.baseURL;

// Opens the app through its Universal/App Link if installed, and falls through
// to the right store if not.
export const DOWNLOAD_LINK_URL = `${downloadBaseURL}/download?${DOWNLOAD_UTM_SOURCE}`;

// Always land on a store, whatever the visitor already has installed.
export const DOWNLOAD_IOS_URL = `${downloadBaseURL}/downloadios?${DOWNLOAD_UTM_SOURCE}`;
export const DOWNLOAD_ANDROID_URL = `${downloadBaseURL}/downloadandroid?${DOWNLOAD_UTM_SOURCE}`;

export const BUILD_NUMBER = Constants.expoConfig?.extra?.buildNumber as
  | number
  | undefined;

export const MARKETING_VERSION = Constants.expoConfig?.extra
  ?.marketingVersion as string | undefined;
